import React from 'react';
import './donorsComponent.scss';
import DonorItemComponent from './donorItem/donorItem';

const DonorsComponent = (props: any) => {
  const { data, token, subscription } = props;

  return (
    <div className="donors-container">
      <div className="row donor-list">
        {data?.map((item: any, index: number) => {
          return (
            <div className="col-md-6 donor-item-content" key={index}>
              <DonorItemComponent item={item} subscription={subscription} token={token} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DonorsComponent;
